import {
  CaretDownOutlined,
  CaretUpOutlined,
  DeleteTwoTone,
  EditTwoTone,
  PlusOutlined,
  SearchOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Button,
  Table,
  Tooltip,
  Form,
  notification,
  PageHeader,
  Row,
  Col,
  InputNumber,
  Tag,
  Input,
} from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import IconNotFound from "../../static/icon/IconNotFound";
import DeleteAction from "../../Tools/DeleteAction";

import { useAuth } from "../../context/auth";
import IconQR from "../../static/icon/IconQR";
import ModalQR from "./ModalQR";
import MerchantDropdown from "../Dropdown/MerchantDropdown";
import LandlordDropdown from "../Dropdown/LandlordDropdown";
import ChargerBrandDropdown from "../Dropdown/ChargerBrandDropdown";
import IconEvCharger from "../../static/icon/IconEvCharger";
import Swal from "sweetalert2";

const Charger = () => {
  const history = useHistory();
  const { accessToken, adminRole } = useAuth();

  const [form] = Form.useForm();
  const selectedMerchants = Form.useWatch('merchantIds', form);

  const [loading, setLoading] = useState(false);

  const [update, setUpdate] = useState(0);
  const [total, setTotal] = useState(0);
  const [chargers, setChargers] = useState([]);
  const [search, setSearch] = useState({
    pageValue: history.location.pageValue ?? {},
    searchValue: history.location.searchValue ?? {},
  });

  useEffect(() => {
    form.setFieldsValue(search.searchValue);
  }, [form, search]);

  const [currentCharger, setCurrentCharger] = useState(null);

  useEffect(() => {
    async function getChargers({ pageValue, searchValue }) {
      setLoading(true);

      const url = new URL('/api/charger', window.location);
      if (searchValue.merchantIds) for (const merchantId of searchValue.merchantIds) url.searchParams.append('merchantId', merchantId);
      if (searchValue.landlordIds) for (const landlordId of searchValue.landlordIds) url.searchParams.append('landlordId', landlordId);
      if (searchValue.id) url.searchParams.append('id', searchValue.id);
      if (searchValue.name) url.searchParams.append('name', searchValue.name);
      if (searchValue.connectorId) url.searchParams.append('connectorId', searchValue.connectorId);
      if (searchValue.connectorName) url.searchParams.append('connectorName', searchValue.connectorName);
      if (searchValue.chargerBrandIds) for (const chargerBrandId of searchValue.chargerBrandIds) url.searchParams.append('chargerBrandId', chargerBrandId);

      if (pageValue.page) url.searchParams.append('page', pageValue.page);
      if (pageValue.size) url.searchParams.append('size', pageValue.size);
      if (pageValue.sort) url.searchParams.append('sort', pageValue.sort);
      if (pageValue.order) url.searchParams.append('order', pageValue.order);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { total, chargers } = await res.json();
        setTotal(total);
        setChargers(chargers);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }

      setLoading(false);
    };

    getChargers(search);
  }, [search, accessToken, update]);

  const [expandeds, setExpandeds] = useState([]);

  const toggleExpanded = (key) => {
    setExpandeds((prev) => {
      const outArr = [...prev];
      if (outArr.includes(key)) {
        return outArr.filter((e) => e !== key);
      } else {
        outArr.push(key);
        return outArr;
      }
    });
  };

  const columns = [
    {
      title: chargers.every((charger) => expandeds.includes(charger.id)) ? (
        <CaretUpOutlined
          style={{ fontSize: 16 }}
          className="cursor-pointer"
          onClick={() => setExpandeds([])}
        />
      ) : (
        <CaretDownOutlined
          style={{ fontSize: 16 }}
          className="cursor-pointer"
          onClick={() => setExpandeds(chargers.map(charger => charger.id))}
        />
      ),
      key: "expand",
      width: 50,
      render: (_, charger) =>
        expandeds.includes(charger.id) ? (
          <CaretUpOutlined
            style={{ fontSize: 16 }}
            className="cursor-pointer"
            onClick={() => toggleExpanded(charger.id)}
          />
        ) : (
          <CaretDownOutlined
            style={{ fontSize: 16 }}
            className="cursor-pointer"
            onClick={() => toggleExpanded(charger.id)}
          />
        ),
    },
    {
      title: "Cluster Name",
      dataIndex: "merchantNameEn",
      key: "merchantNameEn",
      sorter: () => null,
      hidden: !['admin', 'callcenter'].includes(adminRole),
    },
    {
      title: "Site Name",
      dataIndex: "landlordNameEn",
      key: "landlordNameEn",
      sorter: () => null,
      hidden: !['admin', 'merchant', 'party', 'callcenter', 'station'].includes(adminRole),
    },
    {
      title: "Charger Id",
      dataIndex: "id",
      key: "id",
      sorter: () => null,
    },
    {
      title: "Charger Name",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: () => null,
    },
    {
      title: "Charger Brand",
      dataIndex: "chargerBrandName",
      key: "chargerBrandName",
      sorter: () => null,
      render: (chargerBrandName, charger) => chargerBrandName && `${chargerBrandName} (Min Power ${charger.minPowerKw} kW)`,
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, charger) => (
        <span style={{ whiteSpace: "nowrap" }}>
          <Tooltip placement="bottom" title="View" className="mx-1">
            <EditTwoTone
              style={{
                backgroundColor: "#F3F6F9",
                padding: 6,
                borderRadius: 6,
              }}
              onClick={() => {
                history.push({
                  pathname: `/charger/${charger.id}`,
                  searchValue: search.searchValue,
                  pageValue: search.pageValue,
                });
              }}
              twoToneColor="#00C9D6"
            />
          </Tooltip>

          {!charger.active && (
            <Tooltip placement="bottom" title="Delete" className="mx-1">
              <DeleteTwoTone
                style={{
                  backgroundColor: "#F3F6F9",
                  padding: 6,
                  borderRadius: 6,
                }}
                onClick={() => setCurrentCharger(charger)}
                twoToneColor="red"
              />
            </Tooltip>
          )}
        </span>
      ),
    },
  ].filter(column => !column.hidden);

  const [qrCode, setQrCode] = useState(null);

  const statusCharger = (status) => {
    switch (status) {
      case "AVAILABLE":
        return <Tag color="green">Available</Tag>;
      case "PREPARING":
        return <Tag color="orange">Preparing</Tag>;
      case "CHARGING":
        return <Tag color="orange">Charging</Tag>;
      case "PAUSED":
        return <Tag color="orange">Paused</Tag>;
      case "FINISHING":
        return <Tag color="orange">Finishing</Tag>;
      case "UNKNOWN":
        return <Tag color="red">Unknown</Tag>;
      case "UNAVAILABLE":
        return <Tag color="red">Unavailable</Tag>;
      case "FAULTED":
        return <Tag color="red">Faulted</Tag>;
      default:
        return "-";
    }
  };

  const [downloading, setDownloading] = useState(false);
  async function downloadXlsx({ searchValue }) {
    setDownloading(true);

    const url = new URL('/api/charger', window.location);
    url.searchParams.append('mode', 'xlsx');

    if (searchValue.merchantIds) for (const merchantId of searchValue.merchantIds) url.searchParams.append('merchantId', merchantId);
    if (searchValue.landlordIds) for (const landlordId of searchValue.landlordIds) url.searchParams.append('landlordId', landlordId);
    if (searchValue.id) url.searchParams.append('id', searchValue.id);
    if (searchValue.name) url.searchParams.append('name', searchValue.name);
    if (searchValue.connectorId) url.searchParams.append('connectorId', searchValue.connectorId);
    if (searchValue.connectorName) url.searchParams.append('connectorName', searchValue.connectorName);
    if (searchValue.chargerBrandIds) for (const chargerBrandId of searchValue.chargerBrandIds) url.searchParams.append('chargerBrandId', chargerBrandId);

    const res = await fetch(url, {
      headers: { 'X-ACCESS-TOKEN': accessToken },
    });
    if (res.ok) {
      const data = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(data);
      a.download = `Charger_${new Date().toISOString()}.xlsx`;
      a.click();
    } else {
      if (res.status === 404) {
        notification["error"]({
          message: "No matched charger found",
        });
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setDownloading(false);
  }

  return (
    <>
      <div className="flex justify-between items-center mt-2 space-x-4">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconEvCharger /> &nbsp;&nbsp;Charger
            </span>
          }
        />

        {['admin'].includes(adminRole) && (
          <>
            <Button
              className="mt-2 mr-3 flex items-center px-12 border-0"
              loading={downloading}
              type="primary"
              shape="round"
              style={{ background: "#1BC5BD" }}
              onClick={() => Swal.fire({
                title: "Send hard reset all active chargers",
                html: `
                  <label for="swal-token" class="text-center block">Token</label>
                  <input id="swal-token" class="swal2-input">
                  <div id="swal-text"></div>
                `,
                showCancelButton: true,
                confirmButtonText: "Send",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                async preConfirm() {
                  const token = document.getElementById("swal-token").value;
                  const text = document.getElementById("swal-text");

                  const url = new URL(`/api/charger/batch/hard-reset`, window.location);
                  url.searchParams.append('accessToken', accessToken);
                  url.searchParams.append('token', token);

                  const event = new EventSource(url);
                  return await new Promise(resolve => {
                    function update() {
                      text.textContent = `${results.length} / ${size}`;
                      if (results.length === size) {
                        Swal.fire({
                          icon: "success",
                          title: "Sent successfully!",
                          showConfirmButton: false,
                          timer: 1500,
                        });

                        const a = document.createElement('a');
                        a.download = 'hard-reset.csv';
                        a.href = URL.createObjectURL(new Blob([results.map(result => [result.id, '"' + result.result.replace('"', '""') + '"'].join(',')).join('\n')], { type: 'text/csv' }));
                        a.click();

                        resolve();
                      }
                    }

                    let size = 0;
                    let results = [];
                    event.addEventListener('size', (e) => {
                      size = +e.data;
                      update();
                    });
                    event.addEventListener('update', (e) => {
                      results.push(JSON.parse(e.data));
                      update();
                    });
                    event.addEventListener('error', () => event.close());
                  });
                }
              })}
            >
              Hard Reset All
            </Button>

            <Button
              className="mt-2 mr-3 flex items-center px-12 border-0"
              loading={downloading}
              type="primary"
              shape="round"
              style={{ background: "#1BC5BD" }}
              onClick={() => Swal.fire({
                title: "Config all active chargers",
                html: `
                  <label for="swal-token" class="text-center block">Token</label>
                  <input id="swal-token" class="swal2-input">
                  <label for="swal-key" class="text-center block">Key</label>
                  <input id="swal-key" class="swal2-input">
                  <label for="swal-value" class="text-center block pt-4">Value</label>
                  <input id="swal-value" class="swal2-input">
                  <div id="swal-text"></div>
                `,
                showCancelButton: true,
                confirmButtonText: "Send",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                async preConfirm() {
                  const token = document.getElementById("swal-token").value;
                  const key = document.getElementById("swal-key").value;
                  const value = document.getElementById("swal-value").value;
                  const text = document.getElementById("swal-text");

                  const url = new URL(`/api/charger/batch/config`, window.location);
                  url.searchParams.append('accessToken', accessToken);
                  url.searchParams.append('token', token);
                  url.searchParams.append('body', JSON.stringify({ configurations: [{ key, value }] }));

                  const event = new EventSource(url);
                  return await new Promise(resolve => {
                    function update() {
                      text.textContent = `${results.length} / ${size}`;
                      if (results.length === size) {
                        Swal.fire({
                          icon: "success",
                          title: "Sent successfully!",
                          showConfirmButton: false,
                          timer: 1500,
                        });

                        const a = document.createElement('a');
                        a.download = key + '.csv';
                        a.href = URL.createObjectURL(new Blob([results.map(result => [result.id, '"' + result.result.replace('"', '""') + '"'].join(',')).join('\n')], { type: 'text/csv' }));
                        a.click();

                        resolve();
                      }
                    }

                    let size = 0;
                    let results = [];
                    event.addEventListener('size', (e) => {
                      size = +e.data;
                      update();
                    });
                    event.addEventListener('update', (e) => {
                      results.push(JSON.parse(e.data));
                      update();
                    });
                    event.addEventListener('error', () => event.close());
                  });
                }
              })}
            >
              Config All
            </Button>
          </>
        )}

        <Button
          className="mt-2 mr-3 flex items-center px-12 border-0"
          loading={downloading}
          type="primary"
          shape="round"
          style={{ background: "#1BC5BD" }}
          onClick={() => downloadXlsx(search)}
        >
          Export
        </Button>

        <Button
          className="mt-2 flex items-center"
          icon={<PlusOutlined />}
          type="primary"
          shape="round"
          onClick={() => {
            history.push({
              pathname: `/charger/new`,
              searchValue: search.searchValue,
              pageValue: search.pageValue,
            });
          }}
        >
          New Charger
        </Button>
      </div>
      <div className="content">
        <div className="">
          <Form
            form={form}
            layout="vertical"
            onFinish={(values) => setSearch(search => ({
              pageValue: { ...search.pageValue, page: 1 },
              searchValue: values,
            }))}
            onReset={() => form.submit()}
          >
            <Row align="middle" gutter={16}>
              {['admin', 'callcenter'].includes(adminRole) && (
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label="Cluster Name"
                    name="merchantIds"
                    colon={false}
                    initialValue={[]}
                  >
                    <MerchantDropdown
                      allowClear
                      allowSearch
                      mode="multiple"
                      setSelectedMerchants={(merchantIds) => form.setFieldsValue({ merchantIds })}
                    />
                  </Form.Item>
                </Col>
              )}
              {['admin', 'merchant', 'party', 'callcenter', 'station'].includes(adminRole) && (
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label="Site Name"
                    name="landlordIds"
                    colon={false}
                    initialValue={[]}
                  >
                    <LandlordDropdown
                      allowClear
                      allowSearch
                      mode="multiple"
                      merchantIds={selectedMerchants}
                      setSelectedLandlords={(landlordIds) => form.setFieldsValue({ landlordIds })}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Charger Id"
                  name="id"
                  colon={false}
                  initialValue={null}
                >
                  <InputNumber
                    placeholder="Charger Id"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Charger Name"
                  name="name"
                  colon={false}
                  initialValue={''}
                >
                  <Input
                    placeholder="Charger Name"
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Charger Brand Name"
                  name="chargerBrandIds"
                  colon={false}
                  initialValue={[]}
                >
                  <ChargerBrandDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    setSelectedChargerBrands={(chargerBrandIds) => form.setFieldsValue({ chargerBrandIds })}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Connector Id"
                  name="connectorId"
                  colon={false}
                  initialValue={null}
                >
                  <InputNumber
                    placeholder="Connector Id"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Connector Name"
                  name="connectorName"
                  colon={false}
                  initialValue={''}
                >
                  <Input
                    placeholder="Connector Name"
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={14}>
                <div className="flex">
                  <Button
                    className="w-28"
                    type="primary"
                    shape="round"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                  >
                    Search
                  </Button>

                  <Button
                    className="w-28 ml-2"
                    type="primary"
                    ghost
                    shape="round"
                    htmlType="reset"
                    icon={<SyncOutlined />}
                  >
                    Clear Data
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <div className="content">
        <Table
          className="inbox_table"
          locale={{ emptyText: <IconNotFound /> }}
          rowKey={(charger) => charger.id}
          loading={loading}
          columns={columns}
          dataSource={chargers}
          pagination={{
            size: "small",
            current: search.pageValue.page,
            pageSize: search.pageValue.size,
            defaultPageSize: 10,
            total,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
          }}
          onChange={(pagination, _, sorter) => setSearch(search => ({
            pageValue: {
              page: pagination.current ?? 1,
              size: pagination.pageSize ?? 10,
              sort: sorter.columnKey,
              order: sorter.order === 'ascend' ? 'asc' : 'desc',
            },
            searchValue: search.searchValue,
          }))}
          expandable={{
            expandIconColumnIndex: -1,
            onExpandedRowsChange: (e) => setExpandeds(e),
            expandedRowKeys: expandeds,
            expandedRowRender: (charger) => (
              <div key={charger.id}>
                <Row className="expand-custom-header" gutter={[16, 16]}>
                  <Col span={2} className="font-medium">
                    Id
                  </Col>
                  <Col span={4} className="font-medium">
                    Name
                  </Col>
                  <Col span={4} className="font-medium">
                    Connector type
                  </Col>
                  <Col span={4} className="font-medium">
                    Charging Speed
                  </Col>
                  <Col span={4} className="font-medium">
                    Status
                  </Col>
                </Row>
                <Row className="expand-custom-detail" gutter={[16, 16]}>
                  {charger.connectors.map((connector) => {
                    return (
                      <>
                        <Col span={2}>{connector.id}</Col>
                        <Col span={4}>{connector.nameEn}</Col>
                        <Col span={4}>{connector.connectorTypeName}</Col>
                        <Col span={4}>{connector.maxPowerKw} kW</Col>
                        <Col span={4}>{statusCharger(connector.status)}</Col>
                        <Col span={6} className="flex items-center gap-2">
                          <Button
                            size="small"
                            type="link"
                            disabled={typeof connector.judjodId !== 'number'}
                            onClick={() => {
                              Swal.fire({
                                title: `Send open blocker?`,
                                showCancelButton: true,
                                confirmButtonText: "Confirm",
                                showLoaderOnConfirm: true,
                                reverseButtons: true,
                                async preConfirm() {
                                  const url = new URL(`/api/connector/${connector.id}/open-blocker`, window.location);

                                  const res = await fetch(url, {
                                    method: 'POST',
                                    headers: { 'X-ACCESS-TOKEN': accessToken },
                                  });
                                  if (!res.ok) throw new Error();
                                },
                              }).then(result => {
                                if (!result.isConfirmed) return;
                                Swal.fire({
                                  icon: "success",
                                  title: "Send open blocker successfully!",
                                  showConfirmButton: false,
                                  timer: 1500,
                                });
                              }).catch(() => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Failed!",
                                  text: "Failed to send open blocker.",
                                  showConfirmButton: false,
                                  timer: 1500,
                                });
                              });
                            }}
                          >
                            Open blocker
                          </Button>
                          <Button
                            size="small"
                            type="link"
                            disabled={typeof connector.judjodId !== 'number'}
                            onClick={() => {
                              Swal.fire({
                                title: `Send close blocker?`,
                                showCancelButton: true,
                                confirmButtonText: "Confirm",
                                showLoaderOnConfirm: true,
                                reverseButtons: true,
                                async preConfirm() {
                                  const url = new URL(`/api/connector/${connector.id}/close-blocker`, window.location);

                                  const res = await fetch(url, {
                                    method: 'POST',
                                    headers: { 'X-ACCESS-TOKEN': accessToken },
                                  });
                                  if (!res.ok) throw new Error();
                                },
                              }).then(result => {
                                if (!result.isConfirmed) return;
                                Swal.fire({
                                  icon: "success",
                                  title: "Send close blocker successfully!",
                                  showConfirmButton: false,
                                  timer: 1500,
                                });
                              }).catch(() => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Failed!",
                                  text: "Failed to send close blocker.",
                                  showConfirmButton: false,
                                  timer: 1500,
                                });
                              });
                            }}
                          >
                            Close blocker
                          </Button>
                          <button
                            type="button"
                            className="cursor-pointer hover:opacity-80"
                            onClick={() => setQrCode(`${connector.id}`)}
                          >
                            <Tooltip
                              title="Download QR Code"
                              placement="bottom"
                            >
                              <IconQR />
                            </Tooltip>
                          </button>
                        </Col>
                      </>
                    );
                  })}
                </Row>
              </div>
            ),
          }}
        />
      </div>

      <ModalQR
        openModal={!!qrCode}
        qrValue={qrCode}
        onCancel={() => setQrCode(null)}
      />
      <DeleteAction
        openModalActionDelete={!!currentCharger}
        name="Charger"
        type="charger"
        editRecord={currentCharger}
        onCancel={() => setCurrentCharger(null)}
        onOk={() => {
          setCurrentCharger(null);
          setUpdate(update + 1);
        }}
      />
    </>
  );
};

export default Charger;
